/**
 * @file back executor
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { DropBase } from './drop-base';
import { PROP_ORIGINAL_RESOURCE_OID } from '../../domain.service';
var Back = /** @class */ (function (_super) {
    tslib_1.__extends(Back, _super);
    /**
     * Creates an instance of Back.
     */
    function Back(domainService, overlayService, dropTargetsService, dialogService, translateService, userService, resourceService) {
        return _super.call(this, 'back', 'APP.EXECUTORS.FORECAST_BACK_NAME', ['Attendant'], 'Forecast', domainService, overlayService, dropTargetsService, dialogService, translateService, userService, resourceService) || this;
    }
    /**
     * Validate the executor data
     * @param {ExecutorData} data The executor datea
     * @returns {Promise<any>}
     */
    Back.prototype.validate = function (data) {
        // Make sure the given items are of the correct type
        return this.validateItems(data.items);
    };
    /**
     * The business logic for this executor and is executed after the
     * validation step and before the finish step.
     * @param {ExecutorData} data The executor data
     * @returns {Promise<any>}
     */
    Back.prototype.process = function (data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // Run through the items to restore start, finish, and resource
            data.items.forEach(function (item) {
                _this.restoreAttendant(item);
                _this.correctPurpose(item);
            });
            _this.saveChanges(reject, resolve);
        });
    };
    /**
     * Change the start and finish of given item
     * @private
     * @param {Entity} item The entity
     * @memberof Back
     */
    Back.prototype.restoreAttendant = function (item) {
        // Remove the resource from the attendant
        if (item['Resource']) {
            item[PROP_ORIGINAL_RESOURCE_OID] = item['Resource_Oid']; // Met $OriginalResourceOid kunnen we het planbord slim refreshen.
            item['Resource'] = null;
        }
        // if (item['Service'] && item['Service']['Purpose'] && item['Service']['Purpose'] === 'GENERATED') {
        //     // Restore the Start based on StartBase
        //     if (item['Service'] && item['Service']['StartBase']) {
        //         item['Start'] = item['Service']['StartBase'];
        //     }
        //     // Restore the Finish based on FinishBase
        //     if (item['Service'] && item['Service']['FinishBase']) {
        //         item['Finish'] = item['Service']['FinishBase'];
        //     }
        // }
    };
    /**
     * Sets generated items to forecast items, so that they do not disappear when dragged back.
     * See #4142
     * @private
     * @param {Entity} item The entity
     * @memberOf Back
     */
    Back.prototype.correctPurpose = function (item) {
        if (item['Purpose'] === 'GENERATED') {
            item['Purpose'] = 'FORECAST';
        }
    };
    return Back;
}(DropBase));
export { Back };
